import { render, staticRenderFns } from "./CollectionsCarousel.vue?vue&type=template&id=c76e5d50&"
import script from "./CollectionsCarousel.vue?vue&type=script&lang=ts&"
export * from "./CollectionsCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsCarousel.vue?vue&type=style&index=0&id=c76e5d50&prod&lang=scss&module=true&"
import style1 from "./CollectionsCarousel.vue?vue&type=style&index=1&id=c76e5d50&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports